import { useEffect, useRef } from 'react';
import { subscribeProductEvents } from '../utils/productEventsHub';

const useProductEvents = (branchId, onEvent) => {
  const handlerRef = useRef(onEvent);

  useEffect(() => {
    handlerRef.current = onEvent;
  }, [onEvent]);

  useEffect(() => {
    const unsubscribe = subscribeProductEvents((event) => {
      if (branchId && event?.branchId && String(event.branchId) !== String(branchId)) {
        return;
      }
      handlerRef.current?.(event);
    });
    return () => {
      unsubscribe();
    };
  }, [branchId]);
};

export default useProductEvents;
